const SUBSCRIPTION_FORM = {
  POP_UP: 'pop-up',
  FOOTER: 'footer',
  SUBSCRIBE_PAGE: 'subscribe-page',
  CONTACT_US_PAGE: 'contact-us-page',
  OUR_STORY: 'our-story',
  SOCIAL: 'social-page',
}

export { SUBSCRIPTION_FORM }